export const DEEPLINK_KEY = "VTM-DEEPLINK"
export const KLIKK_DEEPLINK = "klikk"

const PRODUCT_PATH_REGEX = /^\/products\/([^/]+)\/?$/

export const saveDeeplink = (): void => {
  try {
    const pathname = globalThis.location.pathname
    const result = PRODUCT_PATH_REGEX.exec(pathname)
    const value = result?.[1]

    if (value) {
      localStorage.setItem(DEEPLINK_KEY, value)
    }
  } catch {}
}

export const getAndUnsetDeeplink = (): string | null => {
  try {
    const value = localStorage.getItem(DEEPLINK_KEY)
    if (value) {
      localStorage.removeItem(DEEPLINK_KEY)
    }
    return value
  } catch {
    return null
  }
}
